import { Link } from "react-router-dom";
import { hotRecommendations } from "@/mocks/home";
import MovieCard from "@/components/base/MovieCard";

export default function HotRecommend() {
  return (
    <section className="w-full px-4 md:px-6 lg:px-8 py-14 md:py-20">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-end justify-between mb-8">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-2">
              热门推荐
            </h2>
            <p className="text-sm text-foreground-500">大家都在看的精彩影视</p>
          </div>
          <Link
            to="/category/movie"
            className="hidden sm:flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap font-medium"
          >
            查看全部
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4 md:gap-5" data-product-shop="">
          {hotRecommendations.map((item) => (
            <MovieCard key={item.id} {...item} />
          ))}
        </div>
      </div>
    </section>
  );
}